import { createFileRoute } from '@tanstack/react-router';

import { SupportPage } from '@/features/support/support-page';

/** Contact support (Settings › Help). Online-only: it talks to KorOS Build staff. */
export const Route = createFileRoute('/_app/support')({ component: SupportPage });
